import { accountTypeOptions, industryOptions, employeeCountOptions } from './pushSegmentOptions';

const optionMap = {
  accountTypes: accountTypeOptions,
  industries: industryOptions,
  employeeCounts: employeeCountOptions,
};

const DEFAULT_PUSH_SEGMENT_SELECTION = {
  accountTypes: [],
  industries: [],
  employeeCounts: [],
};

function convertAllSelectedForSave(values = []) {
  return values.includes('all')
    ? []
    : values.filter(v => v !== 'all');
}

function convertAllSelectedForDisplay(values = [], field) {
  if (!Array.isArray(values)) {
    return [];
  }

  if (values.length === 0) {
    return [
      ...optionMap[field].map(item => item.value),
      'all',
    ];
  }

  return values;
}

/**
 * APIへ送信するデータへ変換
 */
export function buildPushSegmentSelectionForSave(pushStatus, campaignData) {
  if (
    pushStatus !== 'limited' ||
    campaignData.pushSegmentType !== 'selection' ||
    !campaignData.pushSegmentSelectionInfo?.loginFlag
  ) {
    return {
      loginFlag: campaignData.pushSegmentSelectionInfo?.loginFlag ?? true,
      ...DEFAULT_PUSH_SEGMENT_SELECTION
    };
  }

  return {
    loginFlag: campaignData.pushSegmentSelectionInfo?.loginFlag ?? true,
    accountTypes: convertAllSelectedForSave(
      campaignData.pushSegmentSelectionInfo?.accountTypes
    ),
    industries: convertAllSelectedForSave(
      campaignData.pushSegmentSelectionInfo?.industries
    ),
    employeeCounts: convertAllSelectedForSave(
      campaignData.pushSegmentSelectionInfo?.employeeCounts
    ),
  };
}

/**
 * Firestoreから取得したデータを画面表示用へ変換
 */
export function buildPushSegmentSelectionForDisplay(pushStatus, data) {
  if (
    pushStatus !== 'limited' ||
    data.pushSegmentType !== 'selection' ||
    !data.pushSegmentSelectionInfo?.loginFlag
  ) {
    return {
      loginFlag: data.pushSegmentSelectionInfo?.loginFlag ?? true,
      ...DEFAULT_PUSH_SEGMENT_SELECTION,
    };
  }

  return {
    loginFlag: data.pushSegmentSelectionInfo?.loginFlag ?? true,
    accountTypes: convertAllSelectedForDisplay(
      data.pushSegmentSelectionInfo?.accountTypes,
      'accountTypes'
    ),
    industries: convertAllSelectedForDisplay(
      data.pushSegmentSelectionInfo?.industries,
      'industries'
    ),
    employeeCounts: convertAllSelectedForDisplay(
      data.pushSegmentSelectionInfo?.employeeCounts,
      'employeeCounts'
    ),
  };
}
